import DateRangeValidation from './date-range-validation';

class Counter5Reports {
	constructor(config) {
		this.counterReports5Form = config.counterReports5Form;
		this.hasYop = config.hasYop;
		this.formPrefix = config.formPrefix;
		this.dateRangeValidators = config.dateValidationConfigs.map(config => new DateRangeValidation(config));
		this.organizationDropdown = document.querySelector('#selectedOrganization');
		this.selectedFilterGroupInputs = [];
		this.inputGroupsIsValid = true;
		this._handleReportViewsChange = this._handleReportViewsChange.bind(this);
		this._handleReportCustomFilterChange = this._handleReportCustomFilterChange.bind(this);
		this._handleYopChange = this._handleYopChange.bind(this);
		this._handleReportFormChange = this._handleReportFormChange.bind(this);
		this._handleReportFormSubmit = this._handleReportFormSubmit.bind(this);
	}

	get formElement() {
		return document.querySelector(`#${this.counterReports5Form}`);
	}

	get reportViewsEventHolders() {
		return this.formElement.querySelectorAll('.c5-views-wrapper');
	}

	get yopFilterEventHolder() {
		return this.formElement.querySelector('.c5-yop-range-of-years-wrapper') || undefined;
	}

	get customFilterContainer() {
		return this.formElement.querySelector('.c5-custom-filters');
	}

	get yopRangeOfYears() {
		return this.formElement.querySelector('.c5-yop-range-of-years');
	}

	// Handlers
	_handleReportViewsChange(event) {
		if (event.target.getAttribute('data-js') === 'c5-custom-filters') {
			this._showCustomFilters();
		} else {
			this._hideCustomFilters();
		}
	}

	_handleYopChange(event) {
		if (event.target.getAttribute('data-js') === 'c5-yop-range_of_years') {
			this._showYopRangeOfYears();
		} else if (event.target.getAttribute('data-js') === 'c5-yop-all_years') {
			this._hideYopRangeOfYears();
		}
	}

	_handleReportCustomFilterChange(event) {
		this._validateNoEmptyCustomFilterGroup(event);
	}

	_handleReportFormChange(event) {
		this.inputGroupsIsValid = this.dateRangeValidators.every(date => date.startDateValid.valid && date.endDateValid.valid);

		this._handleYopValues(event);
	}

	// UI
	_showCustomFilters() {
		window.sessionStorage.setItem(`${this.formPrefix}-custom-filters`, true);
		this.customFilterContainer.classList.remove('c-inputgroup__radio-conditional--hidden');
	}

	_hideCustomFilters() {
		window.sessionStorage.setItem(`${this.formPrefix}-custom-filters`, false);
		this.customFilterContainer.classList.add('c-inputgroup__radio-conditional--hidden');
	}

	_showYopRangeOfYears() {
		window.sessionStorage.setItem('range-of-years', true);
		this.yopRangeOfYears.classList.remove('c-inputgroup__radio-conditional--hidden');
	}

	_hideYopRangeOfYears() {
		window.sessionStorage.setItem('range-of-years', false);
		this.yopRangeOfYears.classList.add('c-inputgroup__radio-conditional--hidden');
	}

	_metricsForSectionTypeFilters() {
		return this.formElement.querySelectorAll(
			'#tr-metric-type-SN_Total_Chapter_Requests, ' +
				'#tr-metric-type-Unique_Title_Investigations, ' +
				'#tr-metric-type-Unique_Title_Requests'
		);
	}

	_enableMetricTypesForSectionTypeFilters() {
		for (const input of this._metricsForSectionTypeFilters()) {
			input.setAttribute('checked', '');
			input.removeAttribute('disabled');
		}
	}

	_disableMetricTypesForSectionTypeFilters() {
		for (const input of this._metricsForSectionTypeFilters()) {
			input.setAttribute('disabled', '');
			input.removeAttribute('checked');
		}
	}

	_yopErrorMessage(yearLimit, errorMessage) {
		return `<div class="u-display-flex u-position-relative u-width-100 u-padding-top-default">
				<span class="c-inputgroup__validation-text c-inputgroup__validation-text--errored">
					<span class="u-icons c-inputgroup__validation-icon c-inputgroup__validation-icon--errored"
						  style="width:16px; height:16px">
						<svg aria-hidden="true">
							<use href="/static/img/svg-sprite.svg#icon-error"></use>
						</svg>
					</span>
					<span>Choose ${yearLimit} ${errorMessage} YOP for your report</span>
            	</span>
            </div>`;
	}

	_handleYopValues(event) {
		const element = document.querySelector(`#${event.target.id}`);
		const yearLimit = element.getAttribute('data-yop');

		const errorMessages = {
			from: `or later as the first`,
			to: `or earlier as the last`
		};

		const yearInput = element.value;
		const year = Number.parseInt(yearInput, 10);
		let errorText = '';

		if (event.target.id === 'tr-yop-range-from' && year < Number.parseInt(yearLimit, 10)) {
			errorText = this._yopErrorMessage(yearLimit, errorMessages.from);
		} else if (event.target.id === 'tr-yop-range-to' && year > Number.parseInt(yearLimit, 10)) {
			errorText = this._yopErrorMessage(yearLimit, errorMessages.to);
		}

		const errorClass = event.target.id === 'tr-yop-range-from' ? 'js-from-error' : 'js-to-error';
		let errorElement = document.querySelector(`.${errorClass}`);

		if (errorText) {
			const errorMessage = errorText;

			if (!errorElement) {
				errorElement = document.createElement('div');
				errorElement.classList.add(errorClass);
			}
			errorElement.innerHTML = errorMessage;
			document.querySelector('.c5-yop-range-of-years-wrapper').after(errorElement);
		} else if (errorElement) {
			errorElement.innerHTML = '';
		}
	}

	_validateNoEmptyCustomFilterGroup(event) {
		this.filterGroups = this.formElement.querySelectorAll('[data-title="inputgroup-title"]');
		if (this.filterGroups.length === 0) {
			return;
		}

		if (this.hasYop) {
			this._handleYopChange(event);
		}

		// it checks that every inpunt group of the custom filter section is selected
		for (const filterGroup of this.filterGroups) {
			const filterLabel = filterGroup.textContent;
			const pluralizedFilterLabel = filterLabel.endsWith('s') ? filterLabel : `${filterLabel}s`;
			this.filterGroupErrorEmpty = `Choose one or more ${pluralizedFilterLabel} to include`;
			this.filterGroupLegend = filterGroup.parentNode;
			const filterGroupName = this.filterGroupLegend.parentNode.querySelector('input').name;

			const filterGroupInputs = this.formElement.querySelectorAll(`[name="${filterGroupName}"]`);
			if (filterGroupInputs.length > 0) {
				this.selectedFilterGroupInputs = Array.from(filterGroupInputs).filter(
					filterGroupInput => filterGroupInput.checked === true);

				if (filterGroupName === 'sectionType') {
					if (filterGroupInputs.length === this.selectedFilterGroupInputs.length) {
						this._enableMetricTypesForSectionTypeFilters();
					} else {
						this._disableMetricTypesForSectionTypeFilters();
					}
				}

				this._toggleErrorMessage();

				if (this.selectedFilterGroupInputs.length === 0) {
					this.inputGroupsIsValid = false;
				}
			}
		}
	}

	_toggleErrorMessage() {
		if (this.selectedFilterGroupInputs.length === 0) {
			this._showInputgroupError();
		} else {
			this._hideInputgroupError();
		}
	}

	_showInputgroupError() {
		if (this._errorMessageExists(this.filterGroupLegend)) {
			return;
		}
		this.filterGroupLegend.append(this._createContainer(this.filterGroupErrorEmpty));
	}

	_hideInputgroupError() {
		if (this._errorMessageExists(this.filterGroupLegend)) {
			this.filterGroupLegend.lastElementChild.remove();
		}
	}

	_errorMessageExists(container) {
		const errorContainer = container.querySelector('.c-inputgroup__validation-text--errored');

		return errorContainer !== null;
	}

	_errorMessageTemplate(errorText) {
		return `
		<svg  aria-hidden="true" width="16" height="16" class="c-inputgroup__validation-icon c-inputgroup__validation-icon--errored">
				<use href="/static/img/svg-sprite.svg#icon-error"></use>
		</svg>
		<span>${errorText}</span>`;
	}

	_createContainer(errorText) {
		const messageWrapper = document.createElement('span');

		messageWrapper.className = 'c-inputgroup__validation-text c-inputgroup__validation-text--errored';
		messageWrapper.innerHTML = this._errorMessageTemplate(errorText);

		return messageWrapper;
	}

	_handleReportFormSubmit(event) {
		event.preventDefault();

		this._handleReportFormChange(event);
		if (this.inputGroupsIsValid) {
			this.formElement.submit();
		}
	}

	init() {
		for (const validator of this.dateRangeValidators) {
			validator.init();
		}
		if (this.formElement === null || this.formElement === undefined) {
			return;
		}

		// Check the State Persisted in sessionStorage for page reload behavior
		if (sessionStorage.getItem(`${this.formPrefix}-custom-filters`) === 'false' || sessionStorage.getItem(`${this.formPrefix}-custom-filters`) === null) {
			this.formElement.querySelector(`#${this.formPrefix}_custom`).checked = false;
			this._hideCustomFilters();
		} else if (sessionStorage.getItem(`${this.formPrefix}-custom-filters`) === 'true') {
			this.formElement.querySelector(`#${this.formPrefix}_custom`).checked = true;
			this._showCustomFilters();
		} else {
			this.formElement.querySelector(`#${this.formPrefix}_custom`).checked = false;
			this._hideCustomFilters();
		}

		// Listeners
		for (const reportViewsEventHolder of this.reportViewsEventHolders) {
			reportViewsEventHolder.addEventListener('change', this._handleReportViewsChange);
		}

		this.customFilterContainer.addEventListener('change', this._handleReportCustomFilterChange);
		if (this.hasYop) {
			// Check the State Persisted in sessionStorage for page reload behavior
			if (sessionStorage.getItem('range-of-years') === 'false' || sessionStorage.getItem('range-of-years') === null) {
				this.formElement.querySelector('input[type=radio][data-js="c5-yop-range_of_years"]').checked = false;
				this._hideYopRangeOfYears();
			} else if (sessionStorage.getItem('range-of-years') === 'true') {
				this.formElement.querySelector('input[type=radio][data-js="c5-yop-range_of_years"]').checked = true;
				this._showYopRangeOfYears();
			} else {
				this.formElement.querySelector('input[type=radio][data-js="c5-yop-range_of_years"]').checked = false;
				this._hideYopRangeOfYears();
			}
		}

		this.formElement.addEventListener('change', this._handleReportFormChange);
		this.formElement.addEventListener('submit', this._handleReportFormSubmit);
	}
}

export default Counter5Reports;
